var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"buy__card--div",staticStyle:{"height":"100%"}},[_c('img',{staticStyle:{"margin-bottom":"40px"},attrs:{"src":_vm.successImg,"alt":""}}),_c('h1',[_vm._v("支付成功 ")]),_c('a-button',{staticStyle:{"margin-top":"30px"},attrs:{"size":"large"},on:{"click":_vm.backToUserMessage}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }